import classNames from 'classnames';
import { Children } from 'react';
import SectionHeader from '../components/SectionHeader/SectionHeader';

interface LayoutProps {
  useCustomHeader?: boolean;
  title?: string;
  extraWide?: boolean;
  children?: React.ReactNode | React.ReactNode[];
}

const Layout: React.FC<LayoutProps> = ({
  children,
  useCustomHeader,
  title,
  extraWide = false,
}) => {
  const hasTitle = title !== undefined;
  const sizeClasses = classNames({
    'relative px-24 pb-header-height laptop:mx-auto laptop:max-w-[calc(1070px+2*24px)] mb-[86px] laptop:mb-[120px] z-0 mt-[156px] overflow-x-hidden':
      !extraWide,
    'pb-header-height mb-[86px] laptop:mb-[120px] z-0 mt-[130px] tablet:mt-[156px] laptop:mt-[156px] desktop:mt-[156px] px-[25px] desktop:px-[150px]':
      extraWide,
  });
  const layoutClasses = classNames({
    'flex flex-col max-w-layout-content tablet:mx-auto laptop:mx-auto all-but-last-child:mb-64 tablet:all-but-last-child:mb-64 laptop:all-but-last-child:mb-[120px]':
      !extraWide,
    'flex flex-col w-[100%] tablet:w-[100%] laptop:w-[100%] all-but-last-child:mb-64 tablet:all-but-last-child:mb-64 laptop:all-but-last-child:mb-[120px]':
      extraWide,
  });

  const renderChildren = () => {
    if (hasTitle) {
      return (
        <>
          <div className="z-10 mb-24">
            <SectionHeader variant="plakat-large" pageheader>
              {title}
            </SectionHeader>
          </div>
          <div className={layoutClasses}>{children}</div>
        </>
      );
    } else if (useCustomHeader) {
      // For this method the header needs to be the first child
      const [header, ...rest] = Children.toArray(children);
      return (
        <>
          {header}
          <div className={layoutClasses}>{rest}</div>
        </>
      );
    } else {
      return <div className={layoutClasses}>{children}</div>;
    }
  };

  return <div className={sizeClasses}>{renderChildren()}</div>;
};

export default Layout;
